import { combineReducers } from 'redux';

import { Reducer } from '../../../types';
import { UploadMediaState, ArticleAction } from '../types';
import {
  setOpenMediaUpload,
  uploadNewArticleVideoSuccess,
  removeUploadArticleMedia,
  removeAllUploadArticleMedia,
  addDownloadMedia,
  removeDownloadMedia,
  setDownloadMedia,
  removeAllDownloadMedia, createNewArticleUpload, updateNewArticleUpload,
} from '../actions';

/* eslint-disable no-case-declarations, no-param-reassign */

type ReducerOf<T extends keyof UploadMediaState> = Reducer<UploadMediaState, ArticleAction, T>;

const open: ReducerOf<'open'> = (state = false, action) => {
  switch (action.type) {
    case setOpenMediaUpload.type:
      return action.payload;

    default:
      return state;
  }
};

const uploads: ReducerOf<'uploads'> = (state = [], action) => {
  switch (action.type) {
    case uploadNewArticleVideoSuccess.type:
    case createNewArticleUpload.type:
      return state.length > 0 ? [...state, action.payload] : [action.payload];

    case removeUploadArticleMedia.type:
      const index = state.findIndex((item) => item.uploadId === action.payload);
      if (index !== -1) {
        state.splice(index, 1);
      }
      return state;

    case updateNewArticleUpload.type:
      const findedIndex = state.findIndex((item) => item.uploadId === action.payload.uploadId);
      if (findedIndex !== -1) {
        state[findedIndex].signedUrl = action.payload.signedUrl;
      }
      return [...state];

    case removeAllUploadArticleMedia.type:
      return [];

    default:
      return state;
  }
};

const downloads: ReducerOf<'downloads'> = (state = [], action) => {
  switch (action.type) {
    case addDownloadMedia.type:
      return state.length > 0 ? [...state, action.payload] : [action.payload];

    case setDownloadMedia.type:
      const indexMedia = state.findIndex((item) => item.downloadId === action.payload.downloadId);
      if (indexMedia !== -1) {
        state[indexMedia] = action.payload;
        return [...state];
      }
      return state;

    case removeDownloadMedia.type:
      const index = state.findIndex((item) => item.downloadId === action.payload);
      if (index !== -1) {
        state.splice(index, 1);
      }
      return state;

    case removeAllDownloadMedia.type:
      return [];

    default:
      return state;
  }
};

export default combineReducers<UploadMediaState>({
  open,
  uploads,
  downloads,
});
